import FingerprintJS from "@fingerprintjs/fingerprintjs";
const fpPromise = FingerprintJS.load();

async function FingerPrint(): Promise<string> {
    const fp = await fpPromise
    const result = await fp.get()
    return result.visitorId
}
export default FingerPrint;
